//
//
//
//
//
//
//
//
//
//
//
//
//

// import Item from "./components/results/Item.vue";
import VideoLibraryResults from "./components/results/VideoLibraryResults.vue";
import VideoLibraryQuery from "./components/query/VideoLibraryQuery.vue";
export default {
  name: "OICVideoLibrary",
  components: {
    VideoLibraryResults,
    VideoLibraryQuery
	},
  data () {
    return {
      searchSubmitted: false,
      hasFilters: false,
      activeFilters: null
    }
  },
  mounted () {
    const data = this.$store.getters;
    const hasQuery = data.query.length > 0;
    if (hasQuery) {
      this.searchSubmitted = true;
    }
  }
};
